export { DOBComponent } from './dob/dob.component';
